module.exports = __webpack_public_path__ + "img/450.18cf7a21.jpg";